
import {
  defineComponent,
} from '@vue/composition-api';
import FCImage from '~/components/FCImage.vue';
import FCSwiper from '~/components/FCSwiper.vue';
import { isMobileEffect } from '~/effects/matchMedia';

export default defineComponent({
  name: 'InspireFighterSection',
  components: {
    FCImage,
    FCSwiper,
  },
  setup() {
    const slides = [
      {
        title: 'Inspire the fighter within.',
        subtitle: 'Everyone has an inner fighter. This is where you find yours.',
        src: 'https://a.storyblok.com/f/152150/3130x2075/e70695194a/inspire-the-fighter-within.jpg',
        alt: 'Silhouette of a boxer training with a punching bag in a dimly lit gym, with a bright light in the background.',
      },
      {
        title: 'Strength beyond muscle.',
        subtitle: 'This is more than physical. It is about presence, grit, and control under pressure. Strength that is carried beyond the body.',
        src: 'https://a.storyblok.com/f/152150/6000x4000/b0fcc70113/strength-beyond-muscle.jpg',
        alt: 'Person shadowboxing near a waterfront under a bridge, wearing a black outfit and reflective sunglasses, with a cityscape in the background.',
        mobileObjectPosition: '68% 50%',
      },
      {
        title: 'Finish the round.',
        subtitle: 'Because finishing what you start builds more than strength — it builds you.',
        src: 'https://a.storyblok.com/f/152150/7959x5969/7f841d48e7/finish-the-round.jpg',
        alt: 'A woman in workout attire squats near a punching bag in a dimly lit gym, surrounded by various exercise equipment.',
        mobileObjectPosition: '50% 40%',
      },
      {
        title: 'Discipline over motivation.',
        subtitle: 'Confidence isn\'t handed out. It\'s built, one round at a time, until it becomes part of who you are',
        src: 'https://a.storyblok.com/f/152150/6000x4000/8b3e0252b2/discipline-over-motivation.jpg',
        alt: 'Person wearing boxing gloves practicing punches on a white punching bag labeled "Fight Camp" in a dimly lit room.',
        mobileObjectPosition: '24% 50%',
      },
    ];

    const isMobile = isMobileEffect();

    const getImageClass = (slide: any) => {
      if (isMobile.value && slide.mobileObjectPosition) {
        return 'inspire-fighter-section__slide-image--mobile-position';
      }
      return '';
    };

    const getImageStyle = (slide: any) => {
      if (isMobile.value && slide.mobileObjectPosition) {
        return { '--mobile-object-position': slide.mobileObjectPosition };
      }
      return {};
    };

    return {
      slides,
      isMobile,
      getImageClass,
      getImageStyle,
    };
  },
});
